import { Skeleton } from '@/components/ui/skeleton';

export const MyProfileSkeleton = () => {
  return (
    <div className="flex flex-col gap-y-6 p-8 pt-0">
      <div className="flex flex-row justify-center">
        <Skeleton className="h-10 w-48 rounded-md" />
      </div>

      <div className="flex flex-col items-center">
        <div className="flex w-full max-w-lg flex-col gap-4 rounded-lg bg-gradient-to-b from-yellow to-pink p-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex flex-col gap-1">
              <Skeleton className="h-5 w-24" /> {/* etiqueta */}
              <Skeleton className="h-10 w-full rounded-md" /> {/* input */}
            </div>
          ))}
          <Skeleton className="h-10 w-32 self-end rounded-md" /> {/* botón guardar/editar */}
        </div>
        <Skeleton className="mt-4 h-10 w-40 rounded-md" /> {/* botón eliminar cuenta */}
      </div>
    </div>
  );
};
